import React from 'react';

let idCounter = 0;

export function Field({ label, error, hint, required, children }) {
  const [id] = React.useState(() => `field-${++idCounter}`);
  const child = React.isValidElement(children) ? React.cloneElement(children, { id }) : children;
  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1.5">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      {child}
      {hint && !error && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
}

export default function Input({ className = '', error, ...rest }) {
  return (
    <input
      className={`w-full px-3 py-2 border rounded-lg text-sm text-gray-900 placeholder-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:border-primary-500 ${
        error ? 'border-red-400' : 'border-gray-300'
      } ${className}`}
      {...rest}
    />
  );
}

export function Select({ className = '', error, children, ...rest }) {
  return (
    <select
      className={`w-full px-3 py-2 border rounded-lg text-sm text-gray-900 bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:border-primary-500 ${
        error ? 'border-red-400' : 'border-gray-300'
      } ${className}`}
      {...rest}
    >
      {children}
    </select>
  );
}

export function Textarea({ className = '', error, ...rest }) {
  return (
    <textarea
      className={`w-full px-3 py-2 border rounded-lg text-sm text-gray-900 placeholder-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:border-primary-500 ${
        error ? 'border-red-400' : 'border-gray-300'
      } ${className}`}
      {...rest}
    />
  );
}
